/**
 * モック用の共通ユーティリティ
 */

/**
 * 擬似的なAPIレイテンシを再現する遅延
 *
 * @param {number} [ms=300] - 遅延ミリ秒
 */
export function mockDelay(ms = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * 決定的なID採番カウンタを生成する
 *
 * @param {string} prefix - IDの接頭辞
 * @param {number} [start=100] - 開始値
 * @returns {() => string} 呼び出すたびに連番IDを返す関数
 */
export function createIdSequencer(prefix: string, start = 100): () => string {
  let seq = start;
  return () => {
    seq += 1;
    return `${prefix}-${seq}`;
  };
}
